var map = {
	"./Australia.jpg": 994,
	"./NYC2x.png": 995,
	"./SH.png": 996,
	"./bankAccounts.jpg": 369,
	"./buildup.gif": 997,
	"./card.jpg": 998,
	"./globe.png": 999,
	"./hungary.png": 1000,
	"./onlineshopping.gif": 1001,
	"./romania.jpeg": 1002,
	"./sendmoney.gif": 1003,
	"./singapore.jpeg": 1004,
	"./turkey.jpeg": 1005
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 993;